<template>
  <div style="display: inline-block">
    <v-btn v-if="isAdd" small color="primary" outlined @click.stop="dialog = true">
      <v-icon left small>add</v-icon> Add Tier
    </v-btn>
    <v-btn v-else x-small color="secondary" @click.stop="dialog = true">edit</v-btn>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      scrollable
      max-width="700"
      transition="dialog-bottom-transition"
      @click:outside="closeDialog"
    >
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">
          {{ isAdd ? 'Add Tier' : 'Edit Tier' }}
          <v-spacer />
          <v-btn v-if="!isAdd" icon @click="deleteTier"><v-icon color="red">delete</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <v-form v-model="valid" ref="tierForm">
            <v-container grid-list-xs>
              <v-layout row wrap>
                <!-- Tier type -->
                <v-flex xs6>
                  <v-select
                    :items="tierOptions"
                    label="Tier *"
                    v-model="form.tier"
                    :rules="[(v) => !!v || 'Required']"
                    required
                    item-text="text"
                    item-value="value"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-select
                    :items="statusOptions"
                    label="Status"
                    v-model="form.status"
                    item-text="text"
                    item-value="value"
                  />
                </v-flex>

                <!-- Name -->
                <v-flex xs6>
                  <v-text-field
                    label="Name (TH) *"
                    v-model="form.name_th"
                    :rules="[(v) => !!v || 'Required']"
                    required
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Name (EN) *"
                    v-model="form.name_en"
                    :rules="[(v) => !!v || 'Required']"
                    required
                  />
                </v-flex>

                <!-- Description -->
                <v-flex xs6>
                  <v-textarea label="Description (TH)" v-model="form.description_th" rows="2" />
                </v-flex>
                <v-flex xs6>
                  <v-textarea label="Description (EN)" v-model="form.description_en" rows="2" />
                </v-flex>

                <!-- Pricing -->
                <v-flex xs4>
                  <v-text-field
                    label="Price (THB) *"
                    v-model.number="form.price"
                    type="number"
                    :rules="[(v) => (v !== null && v !== '' && v >= 0) || 'Required']"
                    required
                  />
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    label="Full Price (THB) *"
                    v-model.number="form.full_price"
                    type="number"
                    :rules="[(v) => (v !== null && v !== '' && v >= 0) || 'Required']"
                    required
                  />
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    label="Expire After (days) *"
                    v-model.number="form.expire_after_days"
                    type="number"
                    :rules="[(v) => (v !== null && v !== '' && v >= 0) || 'Required']"
                    required
                  />
                </v-flex>

                <!-- Discount -->
                <v-flex xs4>
                  <v-text-field
                    label="Discount Amount *"
                    v-model.number="form.discount_amount"
                    type="number"
                    :rules="[(v) => (v !== null && v !== '' && v >= 0) || 'Required']"
                    required
                  />
                </v-flex>
                <v-flex xs4>
                  <v-select
                    :items="discountUnitOptions"
                    label="Discount Unit *"
                    v-model="form.discount_unit"
                    item-text="text"
                    item-value="value"
                    :rules="[(v) => !!v || 'Required']"
                    required
                  />
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    label="Max Discount (THB) *"
                    v-model.number="form.total_max_discount"
                    type="number"
                    :rules="[(v) => (v !== null && v !== '' && v >= 0) || 'Required']"
                    required
                  />
                </v-flex>

                <!-- Usage -->
                <v-flex xs6>
                  <v-text-field
                    label="Total Usage Limit *"
                    v-model.number="form.total_usage_limit"
                    type="number"
                    :rules="[(v) => (v !== null && v !== '' && v >= 0) || 'Required']"
                    required
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Coupon Count"
                    v-model.number="form.coupon_count"
                    type="number"
                    hint="Coupons generated per purchase"
                    persistent-hint
                  />
                </v-flex>

                <!-- How to use / Terms & Conditions (one bullet per line) -->
                <v-flex xs6>
                  <v-textarea
                    label="How to use (TH)"
                    v-model="form.how_to_use_th"
                    rows="4"
                    hint="One bullet per line"
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    label="How to use (EN)"
                    v-model="form.how_to_use_en"
                    rows="4"
                    hint="One bullet per line"
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    label="Terms & Conditions (TH)"
                    v-model="form.terms_th"
                    rows="4"
                    hint="One bullet per line"
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    label="Terms & Conditions (EN)"
                    v-model="form.terms_en"
                    rows="4"
                    hint="One bullet per line"
                    persistent-hint
                  />
                </v-flex>

                <v-flex xs12>
                  <v-card-actions class="px-0">
                    <v-btn color="accent" :disabled="!valid" @click="submit">
                      {{ isAdd ? 'Create' : 'Update' }}
                    </v-btn>
                    <v-btn text @click="closeDialog">Cancel</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import discountPackage from '../../../services/discountPackage';

export default {
  name: 'AddOrEditTier',
  props: {
    isAdd: { type: Boolean, default: true },
    catalogId: { type: Number, required: true },
    tier: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      form: this.emptyForm(),
      tierOptions: [
        { text: 'Basic', value: 'basic' },
        { text: 'Standard', value: 'standard' },
        { text: 'Plus', value: 'plus' },
      ],
      discountUnitOptions: [
        { text: 'Percent (%)', value: 'percent' },
        { text: 'Fixed Amount (฿)', value: 'amount' },
      ],
      statusOptions: [
        { text: 'Active', value: 'active' },
        { text: 'Inactive', value: 'inactive' },
      ],
    };
  },
  methods: {
    emptyForm() {
      return {
        tier: '',
        name_th: '',
        name_en: '',
        description_th: '',
        description_en: '',
        price: 0,
        full_price: 0,
        discount_amount: 0,
        discount_unit: 'percent',
        total_max_discount: 0,
        total_usage_limit: 1,
        expire_after_days: 30,
        coupon_count: 1,
        status: 'active',
        how_to_use_th: '',
        how_to_use_en: '',
        terms_th: '',
        terms_en: '',
      };
    },
    bulletsToText(bullets) {
      return Array.isArray(bullets) ? bullets.join('\n') : '';
    },
    textToBullets(text) {
      return (text || '')
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line);
    },
    fillForm() {
      if (!this.tier) return;
      const name = this.tier.name || {};
      const desc = this.tier.description || {};
      const tnc = this.tier.term_and_condition || {};
      const tncTh = tnc.th || {};
      const tncEn = tnc.en || {};
      this.form = {
        tier: this.tier.tier || '',
        name_th: name.th || '',
        name_en: name.en || '',
        description_th: desc.th || '',
        description_en: desc.en || '',
        price: this.tier.price ?? 0,
        full_price: this.tier.full_price ?? 0,
        discount_amount: this.tier.discount_amount ?? 0,
        discount_unit: this.tier.discount_unit || 'percent',
        total_max_discount: this.tier.total_max_discount ?? 0,
        total_usage_limit: this.tier.total_usage_limit ?? 1,
        expire_after_days: this.tier.expire_after_days ?? 30,
        coupon_count: this.tier.coupon_count ?? 1,
        status: this.tier.status || 'active',
        how_to_use_th: this.bulletsToText(tncTh.how_to_use),
        how_to_use_en: this.bulletsToText(tncEn.how_to_use),
        terms_th: this.bulletsToText(tncTh.term_and_conditions),
        terms_en: this.bulletsToText(tncEn.term_and_conditions),
      };
    },
    resetForm() {
      this.form = this.emptyForm();
      if (this.$refs.tierForm) this.$refs.tierForm.resetValidation();
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    buildPayload() {
      const tnc = {
        th: {
          how_to_use: this.textToBullets(this.form.how_to_use_th),
          term_and_conditions: this.textToBullets(this.form.terms_th),
        },
        en: {
          how_to_use: this.textToBullets(this.form.how_to_use_en),
          term_and_conditions: this.textToBullets(this.form.terms_en),
        },
      };
      const tncEmpty =
        !tnc.th.how_to_use.length &&
        !tnc.th.term_and_conditions.length &&
        !tnc.en.how_to_use.length &&
        !tnc.en.term_and_conditions.length;
      return {
        catalog_id: this.catalogId,
        tier: this.form.tier,
        name: { th: this.form.name_th, en: this.form.name_en },
        description: { th: this.form.description_th, en: this.form.description_en },
        price: this.form.price,
        full_price: this.form.full_price,
        discount_amount: this.form.discount_amount,
        discount_unit: this.form.discount_unit,
        total_max_discount: this.form.total_max_discount,
        total_usage_limit: this.form.total_usage_limit,
        expire_after_days: this.form.expire_after_days,
        coupon_count: this.form.coupon_count,
        status: this.form.status,
        term_and_condition: tncEmpty ? null : tnc,
      };
    },
    async submit() {
      if (!this.valid) return;
      const payload = this.buildPayload();
      try {
        if (this.isAdd) {
          await discountPackage.createTier(payload);
          this.$notify({ title: 'Success', text: 'Tier created.', type: 'success' });
        } else {
          await discountPackage.updateTier(this.tier.id, payload);
          this.$notify({ title: 'Success', text: 'Tier updated.', type: 'success' });
        }
        this.closeDialog();
        this.$emit('success');
      } catch (error) {
        const msg = error?.response?.data?.error?.message || 'Please try again.';
        this.$notify({ title: 'Error', text: msg, type: 'error' });
      }
    },
    async deleteTier() {
      const confirmed = await this.$root.$confirm(
        'Delete Tier',
        `Delete <b>${this.tier.tier}</b> tier? This action cannot be undone.`,
        { color: 'red' }
      );
      if (!confirmed) return;
      try {
        await discountPackage.deleteTier(this.tier.id);
        this.$notify({ title: 'Success', text: 'Tier deleted.', type: 'success' });
        this.closeDialog();
        this.$emit('success');
      } catch (error) {
        this.$notify({ title: 'Error', text: 'Failed to delete tier.', type: 'error' });
      }
    },
  },
  watch: {
    dialog(val) {
      if (val && !this.isAdd) {
        this.fillForm();
      }
    },
  },
};
</script>
